<template>
  <div class="lockCardApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="card" v-if="active == 0">
      <div class="card commen">
        <h2><div class="ctitle">空间卡</div><a @click="cardcode">扫码领卡<i class="el-icon-arrow-right"></i></a></h2>
        <ul>
          <li v-for="(item,i) in arr" @click="toPush(item.id,'lockcpay')">
            <img class="left" src="~assets/images/card.png">
            <div class="right">
              <h3>{{item.title}}</h3>
              <div class="price">使用时间：<font>{{item.starttime}} 至 {{item.endtime}}</font></div>
              <div class="price">优惠价：
                <font class="rates"><i>￥</i>{{item.rate}}</font>
                <span>￥{{item.price}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="none"  v-if="arr.length <= 0 ">
        <div style="height:80px"></div>
        <img src="~assets/images/no.png" style="display:block;width:100%">
      </div>
    </div>

    <div class="orderfoot"  @click="toPush(1,'lockorder')">查看订单</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        active:0,
        arr:[],
        positionFlag:false,
        code:''
      };
    },
    created(){
      //this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/lockcard');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      cardcode:function(){
        window.location.href="http://user.4008005216.com/main/cardcode"
      },
      toggle(index){
        this.active=index;
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/card/index'
        }).then(function(response){
          var res = response.data;
          that.arr = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .lockCardApp{
    background:#ececec;
  }
  .lockCardApp .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .lockCardApp .commen{
    width:100%;
  }
  .lockCardApp .commen h2{
    margin:0 auto;
    font-size:16px;
    height:50px;
    line-height:50px;
    border-bottom:solid 1px #ececec;
    background:#fff;
  }
  .lockCardApp .commen h2 .ctitle{
    width:70%;
    margin:0 auto;
    position:relative;
    margin-left:4%;
    float:left;
    padding-left:3%
  }
  .lockCardApp .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:16px;
    border-radius: 3px;
  }
  .lockCardApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-right:2%
  }

  .lockCardApp .card ul{
    padding-bottom:15px
  }
  .lockCardApp .card ul li{
    width:100%;
    margin:0px auto 1px auto;
    padding:15px 0;
    background:#fff;
  }
  .lockCardApp .card ul li:last-child{
    border-bottom:none
  }
  .lockCardApp .card ul li .left{
    float:left;
    width:75px;
    border-radius: 6px;
    margin-left:4%
  }
  .lockCardApp .card ul li .right{
    float:left;
    width:70%;
    margin-left:3%
  }
  .lockCardApp .card ul li .right h3{
    font-size:15px
  }
  .lockCardApp .card ul li .right .price{
    color:#666;
    font-size:14px;
    padding-top:8px
  }
  .lockCardApp .card ul li .right .price font{
    color:#000;
  }
  .lockCardApp .card ul li .right .price font.rates{
    color:red;
    font-weight:bold;
    font-size:16px
  }
  .lockCardApp .card ul li .right .price font i{
    font-size:12px;
    font-style:normal;
  }
  .lockCardApp .card ul li .right .price span{
    text-decoration: line-through;
    padding-left:10px
  }

  .lockCardApp .orderfoot{
    position: fixed;
    width:84%;
    height:45px;
    line-height:45px;
    text-align:center;
    color:#fff;
    font-size:15px;
    background: #FF751A;
    bottom:10px;
    left:8%;
    border-radius: 45px;
  }
  
</style>